import { render, staticRenderFns } from "./DescriptionAssuranceSante.vue?vue&type=template&id=71e68b50&scoped=true"
import script from "./DescriptionAssuranceSante.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceSante.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceSante.vue?vue&type=style&index=0&id=71e68b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e68b50",
  null
  
)

export default component.exports